import { useContext } from 'react'

import PropTypes from 'prop-types'

import {
  Box, Button, FormField, ModalContext, SidebarModal,
} from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import useBrandGroup, { useBrandGroupForm } from '@hooks/useBrandGroup'
import useCurrentUser from '@hooks/useCurrentUser'

import EntitySelector from '@components/EntitySelector'

const MODAL_KEY = 'CreateBrandGroupModal'

const CreateBrandGroupModal = (props) => {
  const { callbacks, modalKey = 'CreateBrandModal', showModal } = props
  const { createBrandGroup } = callbacks

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, MODAL_KEY, {})
  const {
    brandGroup: initBrandGroup,
  } = modalPayload

  const brandGroupPayload = useBrandGroup(initBrandGroup)
  const {
    brandGroup,
    callbacks: { createBrandGroup: createFn },
    creating,
  } = brandGroupPayload

  const brandGroupFormPayload = useBrandGroupForm(brandGroup)
  const {
    entityState,
    entityState: {
      brand_id,
      title,
    },
    errors,
    handlers,
    saveEnabled,
    setEntityState,
  } = brandGroupFormPayload

  const createBrandGroupPayload = {
    callbacks: {
      action: createFn,
    },
    entityParams: entityState,
    shouldRedirect: true,
    toastText: 'Brand Group Created',
  }

  const { isBrandUser } = useCurrentUser()

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={modalKey} showModal={showModal} size="small">
      <SidebarModal.Header callbacks={callbacks} title="Create" titleSecondLine="Brand Group" />

      <SidebarModal.Content>
        <Box flexDirection="column" flexShrink={0}>
          <EntitySelector
            boxProps={{ marginBottom: 'large' }}
            callbacks={{
              selectItem: brand => setEntityState({ brand_id: brand ? brand.id : null }),
            }}
            disabled={isBrandUser}
            entityKey="brands"
            errorMessage={errors.brand_id}
            label="* Brand"
            selectedItemId={brand_id}
          />

          <FormField
            direction="column"
            boxProps={{ marginBottom: 'large' }}
            errorMessage={errors.title}
            label="* Group Title"
          >
            <input name="title" value={title} type="text" data-validate-field-on="change" {...handlers} />
          </FormField>
        </Box>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          disabled={!saveEnabled}
          loading={creating}
          onClick={() => createBrandGroup(createBrandGroupPayload)}
          size="large"
        >
          {saveEnabled ? 'Create Brand Group' : 'Complete Fields'}
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

CreateBrandGroupModal.propTypes = {
  callbacks: PropTypes.object.isRequired,
  modalKey: PropTypes.string,
  showModal: PropTypes.bool,
}

const LazyLoadedModal = props => (
  <SidebarModal.RenderController {...props}>
    <CreateBrandGroupModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
